// extracted by mini-css-extract-plugin
export default {"container":"Fca-z","heading":"Gca-z","links":"Hca-z","linkBtn":"Ica-z","disabled":"Jca-z","linkUppercaseBold":"Kca-z","copy":"Lca-z","subCopy":"Mca-z"};